module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag-filter"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": _vm.$tc('user.filter.consumer'),
      "label": "full_name",
      "track-by": "full_name",
      "options": _vm.optionsEditorConsumers,
      "searchable": false,
      "multiple": ""
    },
    on: {
      "input": _vm.inputHandler
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.full_name))])])]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ac698fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/EditorConsumerFilter.vue
// module id = 1016
// module chunks = 1